import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Map, Scissors, HardHat, Zap } from "lucide-react";
const featureCards = [{
  icon: HardHat,
  title: "Veteran-Owned",
  description: "Discipline & integrity on every job"
}, {
  icon: Zap,
  title: "24/7 Emergency",
  description: "Round-the-clock urgent repairs"
}, {
  icon: Map,
  title: "Local Service",
  description: "Kingwood, Porter & Splendora TX"
}, {
  icon: Scissors,
  title: "Free Estimates",
  description: "Transparent, upfront pricing"
}];
export default function Hero() {
  return <section className="relative bg-[#f7f9f7] py-12 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          {/* Left content */}
          <div className="flex flex-col">
            {/* Badge */}
            <div className="mb-4 inline-flex">
              <span className="rounded-full bg-[#1B8439] px-4 py-1.5 text-sm font-semibold text-white">
                Veteran-Owned Garage Door Experts in Texas
              </span>
            </div>

            {/* Headline */}
            <h1 className="text-3xl font-extrabold uppercase tracking-tight text-gray-950 sm:text-4xl lg:text-5xl leading-tight">
              Professional Garage Door Services in Kingwood, TX &amp; Surrounding Areas
            </h1>

            {/* Star rating */}
            <div className="mt-5 flex items-center gap-2">
              <div className="flex">
                {[1, 2, 3, 4, 5].map(s => <svg key={s} className="h-5 w-5 text-[#1B8439]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>)}
              </div>
              <span className="text-sm font-bold text-[#1B8439]">5.0/5.0 Rated</span>
              <span className="text-sm text-gray-500">by Local Families</span>
            </div>

            {/* Value cards */}
            <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {featureCards.map(card => {
              const Icon = card.icon;
              return <div key={card.title} className="flex flex-col items-center rounded-xl border border-[#d4e8db] bg-white px-3 py-3 text-center shadow-sm">
                    <div className="mb-2 flex h-9 w-9 items-center justify-center rounded-full bg-[#e8f4ec]">
                      <Icon className="h-5 w-5 text-[#1B8439]" />
                    </div>
                    <span className="text-xs font-bold text-gray-900 leading-tight">{card.title}</span>
                    <span className="mt-1 text-xs text-gray-500 leading-tight">{card.description}</span>
                  </div>;
            })}
            </div>

            {/* CTA buttons */}
            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:gap-4">
              <Button asChild size="lg" className="w-full sm:w-auto bg-[#1B8439] hover:bg-[#166d2f] text-white font-bold px-6 py-3 rounded-lg">
                <Link to="/contact-us">Request Free Estimate &rarr;</Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="w-full sm:w-auto border-[#1B8439] text-[#1B8439] hover:bg-[#e8f4ec] font-bold px-6 py-3 rounded-lg">
                <a href="tel:7133044798">Call Now 713-304-4798</a>
              </Button>
            </div>
          </div>

          {/* Right image - hidden on small screens */}
          <div className="hidden sm:flex relative justify-center lg:justify-end">
            <div className="relative overflow-hidden rounded-2xl border-4 border-[#1B8439] shadow-2xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1607942/img/ChatGPT-Image-Mar-28-2026-at-03_03_28-PM.png" alt="Professional garage door installation in Kingwood TX" className="h-auto w-full max-w-lg object-cover" onError={e => {
              (e.target as HTMLImageElement).src = "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80";
            }} src="https://schaefergaragedoors.com/wp-content/uploads/2026/06/ChatGPT-Image-Mar-28-2026-at-03_03_24-PM.png" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}